import React, { Component } from 'react';
import * as _ from 'lodash';
import Validator from 'validatorjs';

import { FormControl } from '../../../../facturotopia';
import { RegimenFiscalCatalog } from '../../../../support/catalogs';

class EmisorSectorPrimarioFiscalInfoForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {};
  }

  get rules() {
    return {
      rfc: [
        'required',
        'string',
        'string',
        'max:13',
        'regex:/^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9][A-Z,0-9][0-9,A-Z]$/',
      ],
      razon_social: ['required', 'string'],
      regimen: ['required', 'string'],
      email: ['required', 'string', 'email'],
    };
  }

  componentDidMount() {
    const { data = {} } = this.props;

    this.setRegimes(data.rfc);
  }

  setRegimes = (rfc) => {
    let base = [
      {
        label: 'Selecciona Régimen Fiscal',
        value: '',
      },
    ];

    const filtered = RegimenFiscalCatalog.filter((item) => {
      if (rfc?.length === 13) {
        return item.fisica === 'Sí';
      }

      return item.moral === 'Sí';
    }).map((item) => {
      return {
        label: `${item.descripcion} (${item.clave})`,
        value: item.clave,
      };
    });

    const regimes = _.sortBy(filtered, 'label');

    this.setState({
      regimes: base.concat(regimes),
    });
  };

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    return validator;
  }

  handleOnNominaChange = (value) => {
    const data = {
      nomina: {
        ...this.props.data.nomina,
        ...value,
      },
    };

    this.handleOnChange(data);
  };

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value,
    };

    const validator = this.validate(data);

    if (value?.rfc?.length === 12 || value?.rfc?.length === 13) {
      this.setRegimes(value.rfc);
    }

    this.props.onFormDataChange({
      data,
      step: 'fiscal_info',
      isValid: validator.passes(),
    });
  };

  render() {
    const { data, autoFocus, readOnly = true } = this.props;
    const { regimes } = this.state;
    const rules = this.rules;

    return (
      <>
        <FormControl
          type="text"
          label="RFC"
          name="rfc"
          placeholder="XAXX010101000"
          help=""
          casing="upper"
          readOnly={readOnly}
          rules={rules.rfc}
          value={data.rfc}
          onChange={this.handleOnChange}
        />

        <FormControl
          type="text"
          label="Razón social"
          name="razon_social"
          placeholder="Empresa s.a de c.v"
          help=""
          casing="upper"
          readOnly={readOnly}
          autoFocus={autoFocus}
          rules={rules.razon_social}
          value={data.razon_social}
          onChange={this.handleOnChange}
        />

        <FormControl
          type="select"
          label="Régimen Fiscal"
          name="regimen"
          placeholder=""
          help=""
          rules={rules.regimen}
          value={data.regimen}
          options={regimes}
          onChange={this.handleOnChange}
        />

        <FormControl
          type="email"
          label="Email"
          name="email"
          placeholder="email@example.com"
          help=""
          rules={rules.email}
          value={data.email}
          onChange={this.handleOnChange}
        />
      </>
    );
  }
}

export default EmisorSectorPrimarioFiscalInfoForm;
